(function($) {

	// ------------------------------
	// jquery.SmoothScroll
	// ------------------------------

	// Except
	$('.tabs-title > [href^="#"]').addClass('noscroll');

	$('[href^="#"]:not( [href^="#shop"], [href^="#story"] )').SmoothScroll({
		duration: 700,
		easing: 'swing',
		hash: false
	});

	$('[href^="#shop"], [href^="#story"]').SmoothScroll({
		duration: 700,
		easing: 'swing',
		offset: '200',
		hash: false
	});

})(jQuery);